/**
 * @generated SignedSource<<964ab3a20aab4ed764e9e1552909d4e0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivatePLUFileInput = {
  fileBase64: string;
  name: string;
};
export type ActivatePLUFromStoreFilesScreenMutation$variables = {
  files: ReadonlyArray<ActivatePLUFileInput>;
};
export type ActivatePLUFromStoreFilesScreenMutation$data = {
  readonly activatePLUFromStoreOfficeFile: {
    readonly pluCategories: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
};
export type ActivatePLUFromStoreFilesScreenMutation = {
  response: ActivatePLUFromStoreFilesScreenMutation$data;
  variables: ActivatePLUFromStoreFilesScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "files"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "files",
        "variableName": "files"
      }
    ],
    "concreteType": "ActivatePLUPayload",
    "kind": "LinkedField",
    "name": "activatePLUFromStoreOfficeFile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PLUCategory",
        "kind": "LinkedField",
        "name": "pluCategories",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivatePLUFromStoreFilesScreenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActivatePLUFromStoreFilesScreenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3cfdc39915370c20681ce9d52cc8266a",
    "id": null,
    "metadata": {},
    "name": "ActivatePLUFromStoreFilesScreenMutation",
    "operationKind": "mutation",
    "text": "mutation ActivatePLUFromStoreFilesScreenMutation(\n  $files: [ActivatePLUFileInput!]!\n) {\n  activatePLUFromStoreOfficeFile(files: $files) {\n    pluCategories {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bb478f840ad2282dd0e35104b107acb4";

export default node;
